import classnames from 'classnames';

import { getCursorClass } from 'Components/utils/form/form.util';

const DEFAULT_SIZES = {
  small: 15,
  medium: 23,
  large: 23,
};

export const themes = {
  default: props => {
    const { color, isChecked, isDisabled, isReadOnly, size, validationState } = props;
    return {
      thRoot: 'flex items-center',
      thLabel: classnames(
        'flex items-center text-base px-3',
        getCursorClass({ hasPointer: true, ...props }),
        {
          'font-bold text-blue text-lg': size === 'large',
          'text-emerald': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
          'text-red': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
        },
      ),
      thChecked: classnames(
        'leading-none bg-white border-1 border-solid border-gray-medium flex-shrink-0 p-px rounded-tiny',
        getCursorClass({ hasPointer: true, ...props }),
        {
          'text-blue': isChecked,
          'bg-gray-light opacity-25': isDisabled,
        },
      ),
      thCheckedStyle: {
        width: DEFAULT_SIZES[size],
        height: DEFAULT_SIZES[size],
      },
      thLoading: 'rtl:ml-2 flex items-center leading-none',
      thSwitch: classnames(
        'reset-button border-2 flex items-center transition-all',
        getCursorClass({ hasPointer: true, ...props }),
        {
          'bg-gray-light border-gray-light': isDisabled,
          'bg-gray-darker border-gray-darker': !isChecked && !isDisabled,
          [`bg-${color} border-${color}`]: isChecked && !isDisabled,
        },
      ),
      thSwitchStyle: {
        width: 58,
        padding: '0 1px',
        height: 30,
        borderRadius: 30,
      },
      thSwitchToggler: classnames(
        'bg-white block leading-none flex items-center justify-center rounded-half transition-all',
        {
          'rtl:translate-x-100': isChecked,
          [`text-${color}`]: isChecked && !isDisabled,
        },
      ),
      thSwitchTogglerStyle: {
        width: 28,
        height: 28,
      },
    };
  },
  bubble: props => {
    const { isChecked, isDisabled, isReadOnly, validationState } = props;
    return {
      thRoot: 'relative',
      thLabel: classnames(
        'flex items-center justify-center shadow border-1 rounded py-3 px-5 text-base text-center transition-colors',
        getCursorClass({ hasPointer: true, ...props }),
        {
          'bg-white': !isDisabled,
          'bg-gray-light border-gray-light opacity-50': isDisabled,
          'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
          'border-current text-blue':
            isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
          'border-current text-emerald':
            validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
          'border-current text-red': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
        },
      ),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50',
    };
  },
  bubble2: props => {
    const { isChecked, isDisabled, isReadOnly, validationState } = props;
    return {
      thRoot: 'relative',
      thLabel: classnames(
        'flex items-center justify-center border-1 rounded py-1 px-1 text-base text-center transition-colors',
        getCursorClass({ hasPointer: true, ...props }),
        {
          'bg-white': !isChecked,
          'border-gray-light opacity-50': isDisabled && !isChecked,
          'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
          'border-blue text-white bg-blue':
            isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
          'border-current text-emerald':
            validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
          'border-current text-red': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
          'border-blue text-white bg-blue opacity-50': isDisabled && isChecked,
        },
      ),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50',
    };
  },
};
